import { getOSType } from './getOSType';

export const isWeb = getOSType() === 'Web';
